import React, { useEffect, useRef, useState } from 'react'

import { Wrapper, Phrase, LogosRow, Logo } from './styles'

const PartnersSlider: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)
  const [startScrollAnim, setStartScrollAnim] = useState(false)
  const [isPaused, setIsPaused] = useState(false)

  const totalLogos = 15
  const allLogos = Array.from(
    { length: totalLogos },
    (_, i) => `/images/aboutus/client${i + 1}.svg`
  )
  const half = Math.ceil(totalLogos / 2)
  const logosRow1 = allLogos.slice(0, half)
  const logosRow2 = allLogos.slice(half)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting)
        if (entry.isIntersecting) {
          setTimeout(() => {
            setStartScrollAnim(true)
          }, 100)
        }
      },
      { threshold: 0.1 }
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  return (
    <Wrapper ref={ref}>
      <LogosRow
        direction="left"
        animate={startScrollAnim}
        paused={isPaused}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {[...logosRow1, ...logosRow1].map((logo, i) => (
          <Logo key={i} src={logo} alt={`Logo ${i}`} />
        ))}
      </LogosRow>

      <Phrase isVisible={inView}>
        Nos eligen para construir, nos <br />
        respaldan para crecer.
      </Phrase>

      <LogosRow
        direction="right"
        style={{ paddingBottom: 50 }}
        animate={startScrollAnim}
        paused={isPaused}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {[...logosRow2, ...logosRow2].map((logo, i) => (
          <Logo key={i} src={logo} alt={`Logo ${i}`} />
        ))}
      </LogosRow>
    </Wrapper>
  )
}

export default PartnersSlider
